import { Component, OnInit, ViewChild } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TranslateService } from "@ngx-translate/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { CommonService } from "src/app/core/services/common.service";
import { TokenService } from "src/app/core/services/token.service";
import { QueryFilesPlacaService } from "../services/query-files-placa.service";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { ListValueService } from "src/app/core/services/list-value.service";
import { QueryFilesPlaca } from "../models/queryFilesPlaca";
import { Options } from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-query-files-placa",
  templateUrl: "./query-files-placa.component.html",
  styleUrls: ["./query-files-placa.component.sass"],
})
export class QueryFilesPlacaComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  placaFilesList: QueryFilesPlaca[];
  filtersTable: string;
  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;
  filtersTableJSON;
  filtersSearch = "";
  filterList = FilterConstants.placaQueryFiles;
  tableList = TableConstants.placaQueryFiles;
  routing = RoutingConstants.placaQueryFiles;
  options: Options =
    TableConstants.NotShowCreateDeleteAndArrowUpDownAndHideEditButton;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  constructor(
    private queryFilesPlacaService: QueryFilesPlacaService,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService,
    private listValueService: ListValueService,
    private tokenService: TokenService
  ) {
    this.options.style = { "min-width": "840px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTableDesc(
      "reFecha",
      ScreenConstants.placa.filesPlaca
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
  }

  ngOnInit(): void {
    this.getAnalystList();
    this.getList();
  }

  getList() {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.queryFilesPlacaService.getQueryFilesPlacaList(filters).subscribe(
      (data) => {
        this.placaFilesList = data.content.map((e) =>
          QueryFilesPlaca.queryFilesPlacaFromJson(e)
        );
        this.numPages = data.totalPages == 0 ? 1 : data.totalPages;
        this.numElements = data.numberOfElements;
        this.totalElements = data.totalElements;

        this.sweetAlertService.resetStepsQueue();
        if (data.content && data.content.length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getAnalystList() {
    this.listValueService.listaAnalistasBuzon().subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Analista");
        this.filterList[pos]["selectorConf"].dataList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.getList();
  }

  nombreDoc(item: any) {
    let nombre: string = "PLACA.";
    nombre += item.reFecha.substring(6, 10);
    nombre += item.reFecha.substring(3, 5);
    nombre += item.reFecha.substring(0, 2);
    nombre += item.reFecha
      .substring(12, item.reFecha.length)
      .replaceAll(":", "");
    nombre += ".xml";
    return nombre;
  }

  descargaDoc(item: any) {
    this.queryFilesPlacaService.getDownloadFile(item.id).subscribe(
      (data) => {
        this.commonService.downloadFile(data, this.nombreDoc(item));
      },
      (err) => {
        this.toastrAlertService.toastFailBlob(err.error);
      }
    );
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
